module.exports = __webpack_public_path__ + "Flag-748.2d77d53bce1cc8c638e73fb72ada16d5.svg";